import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator } from '../../../../../../../common/forms/custom.validators';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';

@Injectable()
export class InjuredPersonForm extends AppForm {
  constructor() {
    super({
      firstName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      lastName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      phone: new FormControl('', {
        validators: [Validators.required, CustomValidator.phone(), Validators.maxLength(255)],
        nonNullable: true
      }),
      email: new FormControl('', {
        validators: [
          Validators.required,
          CustomValidator.email(),
          Validators.maxLength(255)
        ],
        nonNullable: true
      }),
      zipCode: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      postOffice: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      city: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      street: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      buildingNumber: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      apartmentNumber: new FormControl('', Validators.maxLength(255))
    });
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues({
      firstName: value?.injuredCorrespondenceFirstName,
      lastName: value?.injuredCorrespondenceLastName,
      phone: value?.injuredCorrespondencePhone,
      email: value?.injuredCorrespondenceEmail,
      zipCode: value?.injuredCorrespondencePostalCode,
      postOffice: value?.injuredCorrespondencePostOffice,
      city: value?.injuredCorrespondenceCity,
      street: value?.injuredCorrespondenceStreet,
      buildingNumber: value?.injuredCorrespondenceHouseNumber,
      apartmentNumber: value?.injuredCorrespondenceApartmentNumber
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      injuredCorrespondenceFirstName: this.value.firstName,
      injuredCorrespondenceLastName: this.value.lastName,
      injuredCorrespondencePhone: this.value.phone,
      injuredCorrespondenceEmail: this.value.email,
      injuredCorrespondencePostalCode: this.value.zipCode,
      injuredCorrespondencePostOffice: this.value.postOffice,
      injuredCorrespondenceCity: this.value.city,
      injuredCorrespondenceStreet: this.value.street,
      injuredCorrespondenceHouseNumber: this.value.buildingNumber,
      injuredCorrespondenceApartmentNumber: this.value.apartmentNumber
    };
  }
}
